// Vendors
import { apiUtils } from '@openbank/cf-ui-architecture-core';
// Constants
import {
  GET_UPLOAD_ID_SERVICE_CONFIGURATION,
  GENERATE_VERIFICATION_URL_SERVICE_CONFIGURATION,
} from './constants/upload-id.service.constants';
// Types
import { UploadApiDataApiResponseType } from '../types/upload-api-data-api-response.type';
import { UploadIdApiResponseType } from '../types/upload-id-api-response.type';

const getUploadIdFlowDataService = async (): Promise<[UploadApiDataApiResponseType, Response]> =>
  apiUtils.get(GET_UPLOAD_ID_SERVICE_CONFIGURATION);

const generateVerificationExpressIdUrlService = async (): Promise<
  [UploadIdApiResponseType, Response]
> => apiUtils.post(GENERATE_VERIFICATION_URL_SERVICE_CONFIGURATION);

export { getUploadIdFlowDataService, generateVerificationExpressIdUrlService };
